import { Separator } from '@ais-ui/ui-core';

import { useLocalization } from '@ais-ui/locale-management';
import { BaseMapList } from './BaseMapList';
import { BaseMapAdd } from './BaseMapAdd';

export function SettingsBaseMapPage() {
  const { messages } = useLocalization();

  return (
    <div className="space-y-6 w-full">
      <div>
        <h3 className="text-2xl font-medium">
          {messages.settingsBaseMapTitle}
        </h3>
        <p className="text-sm text-muted-foreground">
          {messages.settingsBaseMapSubtitle}
        </p>
      </div>
      <Separator className="w-full" />
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-medium">
          {messages.settingsBaseMapListTitle}
        </h3>
        <BaseMapAdd></BaseMapAdd>
      </div>
      <BaseMapList />
    </div>
  );
}
